import Vue from "vue";
import VModal from "vue-js-modal"

export class ModalHelper {
    private _context: any;

    public constructor(context: any) {
        this._context = context;
        Vue.use(VModal, { dialog: true });
    }

    public hide() {
        this._context.$modal.hide("dialog");
    }

    public getModal(options: any) {
        this._context.$modal.show("dialog", options);
    }

    public getConfirmModal(action: (data: any) => void, data: any, text: string): void {
        this.getModal({
            title: "Kinnitus",
            text: text,
            buttons: [
                {
                    title: 'Jah',
                    handler: () => {
                        action(data);
                        this.hide();
                    }
                },
                {
                    title: 'Ei',
                    default: true,
                    handler: () => {
                        this.hide();
                    }
                }
            ]
        });
    }

    public getNotificationModal(title: string, text: string): void {
        this.getModal({
            title: title,
            text: text,
            buttons: [{
                title: "OK",
                handler: () => {
                    this.hide();
                }
            }]
        });
    }
}



// WEBPACK FOOTER //
// ./www/js/Helpers/ModalHelper.ts